export function formatCurrency(
  amount: number,
  currencyCode: string,
  locale: string,
): string {
  const normalizedAmount = Number.isFinite(amount) ? amount : 0;

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(normalizedAmount);
  } catch {
    return `${currencyCode} ${normalizedAmount.toFixed(2)}`;
  }
}
